import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, trackView, resolveImg } from "../lib/api";
import SEO from "../components/SEO";
import { Calendar, ArrowRight } from "lucide-react";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { trackView("/blog"); }, []);
  useEffect(() => {
    (async () => {
      const { data } = await api.get("/blog");
      setPosts(data);
    })();
  }, []);

  return (
    <div className="pt-32 pb-24 bg-[#09090b] text-white min-h-screen">
      <SEO
        title="Journal — Actualités & conseils Blackline Studio"
        description="Tendances design, conseils SEO, retours d'expérience et coulisses de nos projets web. Le journal de Blackline Studio."
        keywords="blog agence web, conseils SEO, tendances design web, journal Blackline Studio"
      />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="text-xs tracking-[0.2em] text-[#d4af37] uppercase mb-4">Journal</div>
        <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl tracking-tight leading-[1.02] mb-6" data-testid="blog-title">
          Actualités <span className="italic font-light">& réflexions</span>.
        </h1>
        <p className="text-zinc-400 max-w-2xl font-light leading-relaxed mb-16">
          Tendances design, conseils SEO, retours d'expérience et coulisses de nos projets.
        </p>

        {posts.length === 0 ? (
          <div className="border border-dashed border-white/10 p-20 text-center" data-testid="no-posts-msg">
            <p className="text-zinc-500 font-light">Articles à venir prochainement.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10">
            {posts.map((p, i) => (
              <Link
                key={p.id}
                to={`/blog/${p.slug}`}
                data-testid={`blog-card-${i}`}
                className="bg-[#0a0a0c] card-lift group block"
              >
                {p.cover_image ? (
                  <div className="aspect-[16/10] overflow-hidden bg-[#18181b]">
                    <img src={resolveImg(p.cover_image)} alt={p.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  </div>
                ) : (
                  <div className="aspect-[16/10] bg-gradient-to-br from-[#18181b] to-[#09090b] flex items-center justify-center text-[#d4af37]/30 font-display text-6xl">B</div>
                )}
                <div className="p-6">
                  <div className="flex items-center gap-2 text-xs text-zinc-500 mb-3">
                    <Calendar size={12} />
                    {new Date(p.created_at).toLocaleDateString("fr-FR", { day: "2-digit", month: "long", year: "numeric" })}
                  </div>
                  <h3 className="font-display text-xl mb-3 group-hover:text-[#d4af37] transition-colors">{p.title}</h3>
                  <p className="text-zinc-400 text-sm font-light line-clamp-3 mb-4">{p.excerpt}</p>
                  <span className="text-[#d4af37] text-sm inline-flex items-center gap-2 link-gold">Lire l'article <ArrowRight size={14} /></span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
